export default "__VITE_ASSET__wUZyxRRM__"